import React, { Component } from 'react';
import Thumbnail from '../Lightbox/Thumbnail';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

class PhotoGallery extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { images, maxToShow, galleryPrefix, t } = this.props;
    return (
      <section className="fe-photo-gallery">
        {images.map((image, idx) => {
          let classStr = '';
          if(idx + 1 > maxToShow) {
            classStr = 'fe-hide';
          }
          return (
            <div key={idx} className={`fe-photo-gallery-thumb ${classStr}`}>
              <div className="fe-u-thumb-4by3">
                { idx + 1 === maxToShow && images.length > maxToShow ?
                  <div className="fe-photo-gallery-more">
                    {t('trip:numMore', { num: `+${images.length - maxToShow}` })}
                  </div> :
                  null
                }
                <Thumbnail
                  id={idx}
                  galleryId={`${galleryPrefix}-gallery`}
                  fullSrc={image.img_url}
                  src={image.thumbnail_url}
                  alt=""
                  isFinalImage={idx + 1 >= images.length}
                />
              </div>
            </div>
          );
        })}
      </section>
    );
  }
}

PhotoGallery.propTypes = {
  images: PropTypes.array.isRequired,
  maxToShow: PropTypes.number.isRequired,
  galleryPrefix: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

PhotoGallery.defaultProps = {
  maxToShow: 4,
  galleryPrefix: '',
};

export default withTranslation()(PhotoGallery);